import React from "react";
import { Link } from "react-router-dom";
import "aos/dist/aos.css"; // Import AOS styles
import AOS from "aos"; // Import AOS
import { useEffect } from "react";
import "../Styles/Product.css";
import ChatBot from "./ChatBot";

function Products() {
  useEffect(() => {
    AOS.init({ duration: 2000 }); // Initialize AOS with custom duration
  }, []);

  return (
    <div className="products-container">
      <div className="products-section" data-aos="fade-up">
        <h1 className="products-title" style={{ color: "white" }}>
          Our Products
        </h1>
        <div className="products-boxes">
          <div className="products-box" data-aos="fade-right">
            <h3>Kids Edu</h3>
            <p>
              An educational mobile app with videos tailored for children of
              different ages, designed to make learning fun and engaging.
            </p>
            <Link to="https://kidsedu.fusion-xe.com" className="read-more">
              Read More →
            </Link>
          </div>
          <div className="products-box" data-aos="fade-left">
            <h3>School Management App</h3>
            <p>
              A comprehensive mobile application with panels for students,
              parents, and teachers, integrated with AI to guide students’
              career paths.
            </p>
            <Link to="https://kidsedu.fusion-xe.com" className="read-more">
              Read More →
            </Link>
          </div>
          <div className="products-box" data-aos="fade-right">
            <h3>E-Commerce</h3>
            <p>
              We have the best and most trusted social media-like market place called kibandaskii where you can purchase
              your products and pay securely with an option to converse with the
              seller directly on WhatsApp. You can visit someone's shop online and see all the products they sell.
            </p>
            <Link to="https://kibandaskii.vercel.app" className="read-more">
              Shop With Us→
            </Link>
          </div>
          <div className="products-box" data-aos="fade-left">
            <h3>Social Media</h3>
            <p>
              Our unique social media platform connects people and fosters
              community engagement through innovative features.
            </p>
            <Link to="/social" className="read-more">
              Read More →
            </Link>
          </div>
        </div>
      </div>
      <ChatBot />
    </div>
  );
};

export default Products;
